var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-post hide-scrollbar render-post-telegram",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("div", { staticClass: "post-header" }, [
        _c("div"),
        _c("p", { staticClass: "name" }, [
          _vm._v(_vm._s(_vm.pages.length == 1 ? _vm.pages[0].name : "Groupe")),
        ]),
        _c(
          "div",
          { staticClass: "img-pages" },
          [
            _vm._l(
              _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
              function (page, index) {
                return [
                  _c(
                    "Tooltip",
                    {
                      key: index,
                      attrs: {
                        active: page.iconEdited,
                        text: "Voir les modifications apportées",
                        position: "right",
                        classCustom: `page ${
                          page.iconEdited ? "iconEdited" : ""
                        }`,
                      },
                      on: {
                        click: () => {
                          _vm.$emit("clickPage", page.id)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: page.avatar ? page.avatar : "img/avatar.jpg",
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ]
              }
            ),
            _vm.pages.length > 4
              ? _c("div", { staticClass: "page count" }, [
                  _vm._v(
                    "\n                +" +
                      _vm._s(_vm.pages.length - 3) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "conversation hide-scrollbar" },
        [
          _c("div", { staticClass: "date" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.datePost ? _vm.formatDatePost : "A l'instant")),
            ]),
          ]),
          _vm.text || _vm.snippet.link
            ? _c("div", { staticClass: "post-content" }, [
                _c("div", { staticClass: "post-text" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.textTranslateMentionAndHastag),
                    },
                  }),
                ]),
                _vm.snippet.link
                  ? _c(
                      "div",
                      { staticClass: "snippet" },
                      [
                        _c("SnippetNetwork", {
                          attrs: { link: _vm.snippet.link },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._l(_vm.commentsTranslateMentionAndHastag, function (comment) {
            return _c("div", { staticClass: "post-content" }, [
              _c("div", { staticClass: "post-text" }, [
                _c("p", { domProps: { innerHTML: _vm._s(comment) } }),
              ]),
            ])
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }